import React, { useContext } from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import DataSlider from '../../../../components/filters/DataSlider'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import { OrderTotals } from '../../../../types/FilterDailyMonitoring'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      textAlign: 'left',
      color: theme.palette.text.secondary
    }
  })
)

const marks = [
  { value: 0, label: 'R$ 0' },
  { value: 1000, label: 'R$ 1k' },
  { value: 2000, label: 'R$ 2k' },
  { value: 3000, label: 'R$ 3k' },
  { value: 4000, label: 'R$ 4k' }
]

export default function OrdersTotals (): JSX.Element {
  const classes = useStyles()
  const { filters, setFilters } = useContext(DailyMonitoringFiltersContext)
  const onChange = (event: React.ChangeEvent<{}>, value: number | number[]) => {
    const valueFormatted: OrderTotals = {
      initial: typeof value === 'number' ? value : value[0],
      final: typeof value === 'number' ? value : value[1]
    }

    setFilters({
      orderTotals: valueFormatted
    })
  }

  return (
    <div className={classes.paper}>
      <Typography id="discrete-slider-custom" gutterBottom>Valor dos Pedidos</Typography>
      <DataSlider
        min={0}
        max={4000}
        step={100}
        defaultValues={filters.orderTotals ? [filters.orderTotals.initial, filters.orderTotals.final] : [0, 4000]}
        marks={marks}
        onChange={onChange}
      />
    </div>
  )
}
